import React from "react";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import { useRequiredAuth } from "../common/guard/requiredAuth";
import SupportInbox from "./pages/SupportInbox";
import SupportTicket from "./pages/SupportTicket";
import OtpLookup from "./pages/OtpLookup";

export default function SupportDeskInnerLayout() {
  const { path } = useRouteMatch();
  const { hasPermissions } = useRequiredAuth();

  if (!hasPermissions(["SUPPORT_DESK_INBOX"])) {
    return <Redirect to="/in/welcome" />;
  }

  return (
    <Switch>
      <Route exact path={path} component={SupportInbox} />
      <Route path={`${path}/otp-lookup`} component={OtpLookup} />
      <Route path={`${path}/ticket/:id`} component={SupportTicket} />
      <Redirect to={path} />
    </Switch>
  );
}
